export const company = "CT Inspection Services LLC";
export const siteName = "CTI Portal";